<template>
  <div
    v-bind="$attrs"
    class="block w-full bg-gray-100 h-1 rounded-sm my-5"
  ></div>
</template>
<script setup lang="ts"></script>
